import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function FilterFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 12v7.883a.999.999 0 01-1.7.83l-2.015-2.016a.998.998 0 01-.285-.832V12h-.026L4.21 4.622A1 1 0 015 3.007V3h14v.007a1 1 0 01.79 1.616L14.026 12H14z"
  }));
}
export default FilterFill;